
import Clarity from "@microsoft/clarity";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import DiscussionSection from "./discussion/DiscussionSection";
import DoctorVisit from "./doctor_visit/DoctorVisit";
import ExpertiseSection from "./expertise/ExpertiseSection";
import InfoSection from "./info/InfoSection";
import IntroSection from "./intro/IntroSection";
import ProfileOtherAction from "./profile_report/ProfileReport";
import PublicationSection from "./publication/PublicationSection";
import VisitSection from "./visit/VisitSection";
import WebinarEnrollSection from "./webinar_enroll/WebinarEnrollSection";
import WebinarMineSection from "./webinar_mine/WebinarMineSection";
import WorkshopEnrollSection from "./workshop_enroll/WorkshopEnrollSection";
import WorkshopMineSection from "./workshop_mine/WorkshopMineSection";

function ProfileMainSections({ isDesktop, profileId, isOwner, onFetchName }) {
	return (
		<div className="flex flex-col gap-4 w-full">
			<ProfileOtherAction profileId={profileId} />
			<InfoSection profileId={profileId} isOwner={isOwner} onFetchName={onFetchName} />
			<IntroSection profileId={profileId} isOwner={isOwner} />
			<ExpertiseSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			<DoctorVisit profileId={profileId} isOwner={isOwner} isDesktop={isDesktop} />
			{isOwner ? <VisitSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} /> : null}
			<WorkshopMineSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			{isOwner ? (
				<WorkshopEnrollSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			) : null}
			<WebinarMineSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			{isOwner ? (
				<WebinarEnrollSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			) : null}
			<PublicationSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
			<DiscussionSection isDesktop={isDesktop} profileId={profileId} isOwner={isOwner} />
		</div>
	);
}

export default function ProfileDetail() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const profileId = params.profileId;
	const isOwner = (profileId == LoginHelper.getProfileId());
	const [profileName, setProfileName] = useState('');

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: profileName || 'پروفایل' },
	];

	useEffect(() => {
		document.title = `پروفایل ${profileName || ""} | همراهتیم`;
	}, [profileName]);

	function onFetchName(name) {
		setProfileName(name);
	}

	const profileColumn = "mx-auto w-full max-w-[560px] px-4";

	return (
		<>
			<Helmet>
				<title>پروفایل {profileName || ""} | همراهتیم</title>
				<meta name="description" content="پروفایل {profileName || ''} به همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white border-b border-[#E2E8F0]">
						<div className={profileColumn}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className={`${profileColumn} py-6 sm:py-8`}>
						<ProfileMainSections
							isDesktop={isDesktop}
							profileId={profileId}
							isOwner={isOwner}
							onFetchName={onFetchName}
						/>
					</div>
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
